import { MEDIA_VIEWER_MIME_TYPES } from '@shared/components';
import { MediaViewerFile } from '@shared/components/media-viewer/media-viewer.models';

export function getSafeUrl(file: MediaViewerFile): string {
  return `data:${getMimeType(file.type)};base64,${file.string}`;
}

export function getExtension(type: string): string {
  if (type.includes('/')) {
    const extension = Object.keys(MEDIA_VIEWER_MIME_TYPES).find((key) => MEDIA_VIEWER_MIME_TYPES[key] === type);
    return extension ?? type.split('/')[1] ?? '';
  }

  return type.replace(/^\./, '').toLowerCase();
}

export function getMimeType(type: string): string {
  if (type.includes('/')) {
    return type;
  }

  const extension = getExtension(type);
  return MEDIA_VIEWER_MIME_TYPES[extension] ?? `image/${extension}`;
}

export function getFileName(file: MediaViewerFile): string {
  const extension = getExtension(file.type);
  const hasExtension = /\.[a-z0-9]+$/i.test(file.name);

  return hasExtension || !extension ? file.name : `${file.name}.${extension}`;
}
